module.exports = __webpack_public_path__ + "img/0Q3A5061_P_L.416471c6.webp";